import(/* webpackMode: "eager" */ "/workspace/node_modules/next/dist/client/link.js");
